import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyHomeComponent } from './empty-home/empty-home.component';
import { SharedComponentsModule } from '../shared-components/shared-components.module';

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
  ],
  declarations: [EmptyHomeComponent]
})
export class HomeModule { }



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts